import { render, staticRenderFns } from "./withdrawalResult.vue?vue&type=template&id=2d6c800b&scoped=true&"
import script from "./withdrawalResult.vue?vue&type=script&lang=js&"
export * from "./withdrawalResult.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalResult.vue?vue&type=style&index=0&id=2d6c800b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6c800b",
  null
  
)

export default component.exports